import { temAcesso } from '@/shared/auth/temAcesso'

const UnidadesRegionais = () => import('./UnidadesRegionais.vue')
const UnidadeRegionalForm = () => import('./UnidadeRegionalForm.vue')
const UnidadeRegionalDetalhe = () => import('./UnidadeRegionalDetalhe.vue')

export default {
    path: 'unidadesregionais',
    name: 'AppSebrae_Consultorias_UnidadesRegionais',
    component: UnidadesRegionais,
    beforeEnter: (to, from, next) => {
        if (temAcesso('APPSE-CONS-UR-00')) {
            next()
        }
    },
    children: [
        {
            path: 'inserir',
            name: 'AppSebrae_Consultorias_UnidadesRegionais_Inserir',
            component: UnidadeRegionalForm,
            beforeEnter: (to, from, next) => {
                if (temAcesso('APPSE-CONS-UR-01')) {
                    next()
                }
            }
        },
        {
            path: ':unidadeRegionalId',
            name: 'AppSebrae_Consultorias_UnidadesRegionais_Detalhar',
            component: UnidadeRegionalDetalhe,
            beforeEnter: (to, from, next) => {
                if (temAcesso('APPSE-CONS-UR-02')) {
                    next()
                }
            }
        },
        {
            path: ':unidadeRegionalId/atualizar',
            name: 'AppSebrae_Consultorias_UnidadesRegionais_Atualizar',
            component: UnidadeRegionalForm,
            beforeEnter: (to, from, next) => {
                if (temAcesso('APPSE-CONS-UR-03')) {
                    next()
                }
            }
        }
    ]
}
